import { mainMenu } from '@/constants/main_menu'
import ManagerRepository from '@/repositories/managerRepository'
const LocalMainMenu = process.env.VUE_APP_LOCAL_MAIN_MENU
export async function getMainMenuList() {
  if (LocalMainMenu === 'true') return mainMenu

  return await ManagerRepository.getMainMenu()
}
